module.exports = __webpack_public_path__ + "static/media/ic_desktop_analytic.dcb1821c.svg";